/* eslint import/no-extraneous-dependencies: "off" */
import { DatePicker } from "antd";
import { PickerPropsWithMultiple } from "antd/es/date-picker/generatePicker/interface";
import dayjs, { Dayjs } from "dayjs";
import { t } from "i18next";
import { PickerRef } from "rc-picker";
import * as React from "react";

export type PropsDatePickerString = Omit<
  PickerPropsWithMultiple<Dayjs>,
  "onChange" | "value"
> & {
  value?: string;
  onChange?(newValue?: string): void;
  srcFormat?: string;
};

// Сейчас дата без времени не модифицируется.
// Если дата со временем, то она считается UTC. Но пользователь видит локальную дату.
// То есть, строковое значение = UTC, а Dayjs (передаётся в Ant DatePicker) = Local.

const s2d = (
  textDate: string | null | undefined,
  showTime: boolean,
): Dayjs | undefined => {
  if (!textDate) return undefined;
  if (showTime) {
    return dayjs.utc(textDate).local();
  }
  return dayjs(textDate);
};
const d2s = (
  date: Dayjs | null | undefined,
  showTime: boolean,
  fmt: string,
): string | undefined => {
  if (!date) return undefined;
  if (showTime) {
    return date.utc().format(fmt);
  }
  return date.format(fmt);
};

/**
 * Компонент для выбора даты (и времени), который использует строковый формат данных
 * @param props
 */
export const DatePickerString = React.forwardRef<
  PickerRef,
  PropsDatePickerString
>((props, ref) => {
  const { value, onChange, srcFormat, format, showTime } = props;
  const valueFormat = srcFormat || `YYYY-MM-DD${showTime ? "THH:mm" : ""}`;
  const dayjsValue = s2d(value, !!showTime);

  const dstFormat =
    format ||
    (showTime
      ? t("DateTimeFormat") || "DD.MM.YYYY"
      : t("DateFormat") || "DD.MM.YYYY HH:mm");

  const iref = React.useRef<PickerRef>(null);
  React.useImperativeHandle(ref, () => iref.current!);

  const onChangeProxy = (d: Dayjs | null): void => {
    iref.current?.focus?.();
    onChange?.(d2s(d, !!showTime, valueFormat));
  };
  return (
    <DatePicker
      {...props}
      placeholder=""
      value={dayjsValue}
      onChange={onChangeProxy}
      format={dstFormat}
      ref={iref}
    />
  );
});
